import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface ForgotPasswordData {
  email: User["email"];
}

export interface ForgotPasswordResponse {
  success: boolean;
  message: string;
}

export const useForgotPassword = () => {
  const [data, setData] = useState<ForgotPasswordResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const forgotPassword = async (formData: ForgotPasswordData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post<ForgotPasswordResponse>(
        "users/users/password_reset/",
        formData,
      );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, forgotPassword };
};
